import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import InlineSVG from 'svg-inline-react';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as localStorage from '../../../localStorage/localStorage';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as objectConstants from '../../../constants/objectConstants';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {COMPONENT_TOOLTIP_OBJECT, COMPONENT_KPI_DASHBOARD_OBJECT} from '../../../constants/componentConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';

class Badge extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            badge: this.props.badge,
            userBadge: this.props.userBadge,
            showAchievedCount: this.props.userBadge,
            showAchievedState: this.props.showAchievedState,
            currentBadgeId: appHelper.isDefined(this.props.currentBadgeId) ? this.props.currentBadgeId : "",
            locale: appHelper.getLocalData(this.props.badge),
            icon: {
                src: "",
            },
            earnedBadge: {},
            unearnedBadge: {}

        };

        this.getBadgeClass = this.getBadgeClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onBadgeClicked = this.onBadgeClicked.bind(this);
        this.getActiveClass = this.getActiveClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {

        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userBadge !== nextProps.userBadge) {
            this.setState({userBadge: Object.assign({}, nextProps.userBadge)});
        }
        if (this.state.showAchievedCount !== nextProps.showAchievedCount) {
            this.setState({showAchievedCount: nextProps.showAchievedCount});
        }
        if (this.state.showAchievedState !== nextProps.showAchievedState) {
            this.setState({showAchievedState: nextProps.showAchievedState});
        }

        if (appHelper.isDefined(nextProps.currentBadgeId) && this.state.currentBadgeId !== nextProps.currentBadgeId) {
            this.setState({currentBadgeId: nextProps.currentBadgeId});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.badge),
            });
        }
    }


    getAssets() {
        let icon = {};
        let earnedBadge = {};
        let unearnedBadge = {};

        if (this.state.badge.icon.constant === assetConstants.ASSET_TYPE_ICON) {
            icon = appHelper.getIconAsset(this.state.badge.icon);
        } else if (this.state.badge.icon.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            icon = appHelper.getLibraryImageAsset(this.state.badge.icon);
        }

        if (appHelper.isDefined(this.state.badge.badge_type) && this.state.badge.badge_type === objectConstants.BADGE_TYPE_IMAGE) {
            if (appHelper.isDefined(this.state.locale.image) && appHelper.isDefined(this.state.locale.image.earned.file_name)) {
                earnedBadge = appHelper.getEarnedAsset(this.state.locale.image.earned);
            }

            if (appHelper.isDefined(this.state.locale.image) && appHelper.isDefined(this.state.locale.image.unearned.file_name)) {
                unearnedBadge = appHelper.getUnearnedAsset(this.state.locale.image.unearned);
            }
        }

        this.setState({
            icon: Object.assign({}, appHelper.isDefined(icon.src) ? icon : this.state.icon),
            earnedBadge: Object.assign({}, appHelper.isDefined(earnedBadge.src) ? earnedBadge : this.state.earnedBadge),
            unearnedBadge: Object.assign({}, appHelper.isDefined(unearnedBadge.src) ? unearnedBadge : this.state.unearnedBadge),
        });
    }


    getBadgeClass() {
        return this.state.userBadge.achieved === 0 && this.props.showAchievedState ? 'not-achieved' : 'achieved';
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    onBadgeClicked(event) {
        event.stopPropagation();
        event.preventDefault();
        if (appHelper.isDefined(this.props.onClicked)) {
            if (this.state.badge.badge_id !== this.state.currentBadgeId) {
                this.props.onClicked(this.state.badge.badge_id, this.state.locale);
            } else {
                this.props.onClicked("", {});
            }

        }

    }

    getActiveClass() {
        return this.state.badge.badge_id === this.state.currentBadgeId ? 'active' : '';
    }

    setKeyboardAccessibility(event) {

    }

    //<InlineSVG className="guroo-icon" src={this.getImagePath(this.state.icon.src)}/>
    render() {
        return (
            this.state.badge.badge_type === objectConstants.BADGE_TYPE_SHIELD
                ?
                <div className={`badge ${this.getActiveClass()}`} onClick={this.onBadgeClicked}
                     onKeyDown={this.setKeyboardAccessibility} onFocus={this.onBadgeClicked}
                     onMouseOver={this.onBadgeClicked} onMouseOut={this.onBadgeClicked} onBlur={this.onBadgeClicked}
                     id={`badge_${this.state.badge.badge_id}`}
                     tabIndex={appHelper.isDefined(this.props.onClicked) ? 0 : -1} role="link">
                    <div className={`badge-container ${this.getBadgeClass()}`}>
                        <div className="badge-icon">
                            <img src={this.getImagePath(this.state.icon.src)} alt=""/>
                        </div>

                    </div>
                    <div className="badge-label" dangerouslySetInnerHTML={{__html: this.state.locale.short_title}}/>

                    {this.state.userBadge.achieved > 1 && this.props.showAchievedCount
                        ? <div className="achieved-count">x{this.state.userBadge.achieved}</div>
                        : null
                    }
                    <div className="hidden">
                        {appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title !== null && this.state.locale.long_title.length > 0
                            ?
                            <h4 dangerouslySetInnerHTML={{__html: this.state.locale.long_title}}/>
                            :
                            null
                        }
                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null  && this.state.locale.description.length > 0
                            ?
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            :
                            null
                        }
                    </div>
                </div>
                :
                <div className={`image-badge`} onClick={this.onBadgeClicked} onKeyDown={this.setKeyboardAccessibility}
                     onFocus={this.onBadgeClicked} onMouseOver={this.onBadgeClicked} onMouseOut={this.onBadgeClicked}
                     onBlur={this.onBadgeClicked} id={`badge_${this.state.badge.badge_id}`}
                     tabIndex={appHelper.isDefined(this.props.onClicked) ? 0 : -1} role="link">
                    {this.state.userBadge.achieved === 0 && this.props.showAchievedState
                        ?
                        <img src={this.getImagePath(this.state.unearnedBadge.src)} alt=""/>
                        :
                        <img src={this.getImagePath(this.state.earnedBadge.src)} alt=""/>
                    }
                    <div className="hidden">
                        <div className="hidden">
                            {appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title.length > 0
                                ?
                                <h5 dangerouslySetInnerHTML={{__html: this.state.locale.long_title}}/>
                                :
                                null
                            }
                            {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null  && this.state.locale.description.length > 0
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>

        );
    }
}

Badge.propTypes = {
    badge: PropTypes.object.isRequired,
    userBadge: PropTypes.object.isRequired,
    showAchievedCount: PropTypes.bool.isRequired,
    showAchievedState: PropTypes.bool.isRequired,
    onClicked: PropTypes.func,
    currentBadgeId: PropTypes.number,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

Badge.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Badge);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/Badge.js
 **/